/**
 * 분석 재료 현황 API — `GET /api/fo/analysis/readiness`(서버 SSoT, 8항목).
 *
 * GNB 진행 레일(`useWorkspaceProgress`)과 검사 화면 재료 칩(`useMaterialsStatus`)이 같은 응답을 읽는다.
 * 글로벌 에러 처리는 http.ts 인터셉터 1회로 일원화 — 호출부 catch 에서 중복 알림 금지.
 */
import { http } from '#/api/http';

export type ReadinessMissingKey = 'SCORE' | 'DIAGNOSIS' | 'TEST';

/** 재료 8항목 키 — 응답 `items[]` 순서 고정. */
export type MaterialKey =
  | 'SUNEUNG'
  | 'NAESIN'
  | 'DIAG_JEONGSI'
  | 'DIAG_SUSI'
  | 'TEST_CAREER'
  | 'TEST_LEARNING'
  | 'TEST_PSYCH'
  | 'TEST_ADMISSION';

export type MaterialStatus = 'FILLED' | 'EMPTY';

export interface MaterialItem {
  key: MaterialKey;
  status: MaterialStatus;
  /** 보조 표기(내신 입력 범위·건수). 없으면 null. */
  detail: string | null;
}

export interface Readiness {
  scoreEntered: boolean;
  suneungEntered: boolean;
  naesinEntered: boolean;
  diagnosisCount: number;
  completedTestCodes: string[];
  totalTestCount: number;
  /** 성적·진단·검사 중 1종 이상 보유(FR-021). */
  canGenerate: boolean;
  missing: ReadinessMissingKey[];
  /** 재료 8항목(순서 고정). */
  items: MaterialItem[];
}

/** 재료 현황 — 레일·재료 칩이 공유하는 단일 판정 소스(쿼리 키 `['analysis','readiness']`). */
export async function fetchReadiness(): Promise<Readiness> {
  const { data } = await http.get<Readiness>('/fo/analysis/readiness');
  return data;
}
